import React, { useEffect, useState } from "react";
import { apiKey } from "../../../../config/config";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
import MessageCard from "../../../../components/AdminCards/MessageCard";
import axios from "axios";

function DetailedSaleReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [columns] = useState([
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },

    {
      header: "Date",
      cell: (row) =>
        new Date(row.row.original.sale_date).toISOString().split("T")[0],
    },
    {
      header: "Reference ",
      accessorKey: "sale_no",
    },
    {
      header: "Order Type",
      cell: (order) => order.row.original.order_type.name,
    },
    {
      header: "Total Item",
      accessorKey: "total_items",
    },
    {
      header: "Subtotal",
      accessorKey: "sub_total",
    },
    {
      header: "Discount",
      accessorKey: "total_discount_amount",
    },
    {
      header: "Service/Delivery Charges",
      accessorKey: "delivery_charges",
    },
    {
      header: "Vat",
      accessorKey: "vat_amount",
    },
    {
      header: "G. Total",
      accessorKey: "total_payable",
    },
    {
      header: "Payment Method",
      // accessorKey: "Payment Method",
      cell: (order) => order.row.original.payment.name,
    },
  ]);
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [error, setError] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedPayment, setSelectedPayment] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  // const [buttonDataa] = useState([
  //  {
  //   buttonText: "Submit"
  //  }
  // ]);

  const handleUserSelect = (e) => {
    setSelectedUser(e.value);
  };
  const handlePaymentSelect = (e) => {
    setSelectedPayment(e.value);
  };

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const selectButton = [
    {
      placeholder: "User",
      options: users,
      onChange: handleUserSelect,
    },
    // {
    //   placeholder: "Multi User",
    // },
    {
      placeholder: "Payment Method",
      options: paymentMethods,
      onChange: handlePaymentSelect,
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/details-sales-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          user_id: selectedUser,
          payment_id: selectedPayment,
          start_date: startDate,
          end_date: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [
    endDate,
    selectedPayment,
    selectedUser,
    startDate,
    selectedOutlet,
    user?.token,
    user?.user.outlet_id,
  ]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCustomers = res.data.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(mappedCustomers);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
    axios
      .get(`${apiKey}/api/rms/admin/payment_methods`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedPayments = res.data.map((payment) => ({
          value: payment.id,
          label: payment.name,
        }));
        setPaymentMethods(mappedPayments);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Detailed Sale Report"}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        //  buttonDataa={buttonDataa}
        selectButton={selectButton}
        downloads={true}
        handleOutletSelect={handleOutletSelect}
      />
    </main>
  );
}

export default DetailedSaleReport;
